var $4e7cd115b71f013d$exports = {};
$4e7cd115b71f013d$exports = {
    "valid": `Va\u{17E}e\u{107}e`
};


export {$4e7cd115b71f013d$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
